export default __webpack_public_path__ + "static/media/neobeshala.ace5441e.mp3";